var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.3701V65.625C0 70.7959 13.1016 75 29.25 75C45.3984 75 58.5 70.7959 58.5 65.625V59.3701C52.2082 63.6328 40.7062 65.625 29.25 65.625C17.7938 65.625 6.2918 63.6328 0 59.3701ZM48.75 18.75C64.8984 18.75 78 14.5459 78 9.375C78 4.2041 64.8984 0 48.75 0C32.6016 0 19.5 4.2041 19.5 9.375C19.5 14.5459 32.6016 18.75 48.75 18.75ZM0 44.0039V51.5625C0 56.7334 13.1016 60.9375 29.25 60.9375C45.3984 60.9375 58.5 56.7334 58.5 51.5625V44.0039C52.2082 48.9844 40.691 51.5625 29.25 51.5625C17.809 51.5625 6.2918 48.9844 0 44.0039ZM63.375 45.6152C72.1043 43.9893 78 40.9717 78 37.5V31.2451C74.4656 33.6475 69.2707 35.2881 63.375 36.2988V45.6152ZM29.25 23.4375C13.1016 23.4375 0 28.6816 0 35.1562C0 41.6309 13.1016 46.875 29.25 46.875C45.3984 46.875 58.5 41.6309 58.5 35.1562C58.5 28.6816 45.3984 23.4375 29.25 23.4375ZM62.659 31.6846C71.7996 30.1025 78 26.9971 78 23.4375V17.1826C72.5918 20.8594 63.2988 22.8369 53.5184 23.3057C58.0125 25.4004 61.3184 28.2129 62.659 31.6846Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuationIcon);
export default __webpack_public_path__ + "static/media/valuation_icon.974fd08e785f5816749072d3facef6b2.svg";
export { ForwardRef as ReactComponent };